import { BusinessError, EntityKind, ErrorKind, GestionDepotDemandePublicSettingsSchema, buildBusinessErrorFromError, } from '@mgdis/eu-domain';
class PublicSettingsRestAdapter {
    tenantId;
    restHttpAdapter;
    /**
     * API of sollicitations.
     */
    constructor({ tenantId, restHttpAdapter }) {
        this.tenantId = tenantId;
        this.restHttpAdapter = restHttpAdapter;
    }
    /**
     * Call API: get public settings
     */
    async getPublicSettings() {
        try {
            const res = await this.restHttpAdapter.get(`/aides/admin/tenants/${this.tenantId}/publicSettings`, {
                params: { merge: 'true' },
            }, true);
            return {
                response: {
                    data: res.data,
                    headers: res.headers,
                },
            };
        }
        catch (error) {
            return { error: buildBusinessErrorFromError(error) };
        }
    }
    async getPublicSettingsGestionDepotDemandes() {
        const url = `/gestion-depot-demandes/admin/tenants/${this.tenantId}/publicSettings`;
        try {
            const res = await this.restHttpAdapter.get(url, {
                params: { merge: 'true' },
            });
            const result = await GestionDepotDemandePublicSettingsSchema.safeParseAsync(res.data);
            if (!result.success) {
                return {
                    error: new BusinessError(ErrorKind.TECHNICAL_ERROR, {
                        entity: EntityKind.TIERS,
                        message: `[public-settings-rest.adapter] (getPublicSettingsGestionDepotDemandes) Error parsing gestion depot demandes public settings. ${result.error.message}`,
                    }),
                };
            }
            return {
                response: result.data,
            };
        }
        catch (error) {
            return { error: buildBusinessErrorFromError(error) };
        }
    }
}
export { PublicSettingsRestAdapter };
//# sourceMappingURL=public-settings-rest.adapter.js.map